import { AppUtils } from '../../utils/index';

import { BehindertenausweisApi } from '../generated/MitgliedschaftBehindertenausweisApi';
import { AntragsstellerApi } from '../generated/MitgliedschaftAntragsstellerApi';
import { PartnerApi } from '../generated/MitgliedschaftPartnerApi';
import { KindApi } from '../generated/MitgliedschaftKindApi';
import { BankApi } from '../generated/PersonBankApi';
import { MglBasisAnlage } from './MglBasisAnlage';


/**
 * APIL Url: /Help/ResourceModel?modelName=Anlage
 */
export class MglAnlage extends MglBasisAnlage {

	private avisNr: number;
	/**
	 * Description: Avis Nummer
	 * APIL Type: integer
	 */
	get AvisNr(): number {
		return this.avisNr;
	}

	/**
	 * Description: Avis Nummer
	 * APIL Type: integer
	 */
	set AvisNr(value: number) {
		this.avisNr = value;
	}

	private werbernummer: number;
	/**
	 * Description: Nummer des Werbenden
	 * APIL Type: integer
	 */
	get Werbernummer(): number {
		return this.werbernummer;
	}

	/**
	 * Description: Nummer des Werbenden
	 * APIL Type: integer
	 */
	set Werbernummer(value: number) {
		this.werbernummer = value;
	}

	private werbegeschenk: number;
	/**
	 * Description: Nummer der Prämie
	 * APIL Type: integer
	 */
	get Werbegeschenk(): number {
		return this.werbegeschenk;
	}

	/**
	 * Description: Nummer der Prämie
	 * APIL Type: integer
	 */
	set Werbegeschenk(value: number) {
		this.werbegeschenk = value;
	}

	private werbetext: string;
	/**
	 * Description: Werbetext
	 * APIL Type: string
	 */
	get Werbetext(): string {
		return this.werbetext;
	}
	/**
	 * Description: Werbetext
	 * APIL Type: string
	 */
	set Werbetext(value: string) {
		this.werbetext = value;
	}

	private motorweltverzicht: boolean;
	/**
	 * Description: Soll auf die Motorwelt verzichtet werden, z.B. bei englischsprachigen Anträgen
	 * APIL Type: boolean
	 */
	get Motorweltverzicht(): boolean {
		return this.motorweltverzicht;
	}

	/**
	 * Description: Soll auf die Motorwelt verzichtet werden, z.B. bei englischsprachigen Anträgen
	 * APIL Type: boolean
	 */
	set Motorweltverzicht(value: boolean) {
		this.motorweltverzicht = value;
	}

	private istSchwerbehindert: boolean;
	/**
	 * Description: Kunde ist schwerbehindert
	 * APIL Type: boolean
	 */
	get IstSchwerbehindert(): boolean {
		return this.istSchwerbehindert;
	}

	/**
	 * Description: Kunde ist schwerbehindert
	 * APIL Type: boolean
	 */
	set IstSchwerbehindert(value: boolean) {
		this.istSchwerbehindert = value;
	}

	private behindertenausweis: BehindertenausweisApi;
	/**
	 * Description: Details des Schwerbehindertenausweis wenn IsSchwerbehindert gleich true
	 * APIL Type: Behindertenausweis
	 */
	get Behindertenausweis(): BehindertenausweisApi {
		return this.behindertenausweis;
	}

	/**
	 * Description: Details des Schwerbehindertenausweis wenn IsSchwerbehindert gleich true
	 * APIL Type: Behindertenausweis
	 */
	set Behindertenausweis(value: BehindertenausweisApi) {
		this.behindertenausweis = value;
	}

	private hatPartner: boolean;
	/**
	 * Description: Flag welches anzeigt ob ein Partner vorhanden ist.&#10;            Dient Clients zur Erleichterung welche nur mit Formularen ohne JS arbeiten.
	 * APIL Type: boolean
	 */
	get HatPartner(): boolean {
		return this.hatPartner;
	}

	/**
	 * Description: Flag welches anzeigt ob ein Partner vorhanden ist.&#10;            Dient Clients zur Erleichterung welche nur mit Formularen ohne JS arbeiten.
	 * APIL Type: boolean
	 */
	set HatPartner(value: boolean) {
		this.hatPartner = value;
	}

	private partner: PartnerApi;
	/**
	 * Description: Daten des (Ehe-)Partners
	 * APIL Type: Partner
	 */
	get Partner(): PartnerApi {
		return this.partner;
	}

	/**
	 * Description: Daten des (Ehe-)Partners
	 * APIL Type: Partner
	 */
	set Partner(value: PartnerApi) {
		this.partner = value;
	}

	private hatKinder: boolean;
	/**
	 * Description: Flag welches anzeigt ob Kinder vorhanden sind.&#10;            Dient Clients zur Erleichterung welche nur mit Formularen ohne JS arbeiten.
	 * APIL Type: boolean
	 */
	get HatKinder(): boolean {
		return this.hatKinder;
	}

	/**
	 * Description: Flag welches anzeigt ob Kinder vorhanden sind.&#10;            Dient Clients zur Erleichterung welche nur mit Formularen ohne JS arbeiten.
	 * APIL Type: boolean
	 */
	set HatKinder(value: boolean) {
		this.hatKinder = value;
	}

	private kinder: Array<KindApi>;
	/**
	 * Description: Liste der Kinder
	 * APIL Type: Collection of Kind
	 */
	get Kinder(): Array<KindApi> {
		return this.kinder;
	}

	/**
	 * Description: Liste der Kinder
	 * APIL Type: Collection of Kind
	 */
	set Kinder(value: Array<KindApi>) {
		this.kinder = value;
	}

	private englisch: boolean;
	/**
	 * Description: Antrag ist englischsprachlich gestellt worden
	 * APIL Type: boolean
	 */
	get Englisch(): boolean {
		return this.englisch;
	}

	/**
	 * Description: Antrag ist englischsprachlich gestellt worden
	 * APIL Type: boolean
	 */
	set Englisch(value: boolean) {
		this.englisch = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): MglAnlage {
		let result: Array<KindApi>;
		return AppUtils.Helper.createFromMap(dataObject, MglAnlage, (key: string, value: any) => {
			switch (key) {
				case 'behindertenausweis':
					return BehindertenausweisApi.createFromObject(value);
				case 'antragssteller':
					return AntragsstellerApi.createFromObject(value);
				case 'partner':
					return PartnerApi.createFromObject(value);
				case 'kinder':
					result = new Array<KindApi>();
					(value as Record<string, any>[]).forEach(v => {
						result.push(KindApi.createFromObject(v));
					});
					return result;
				case 'bankdaten':
					return BankApi.createFromObject(value);
				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result = super.toRequestObject();
		result.AvisNr = this.avisNr;
		result.Werbernummer = this.werbernummer;
		result.Werbegeschenk = this.werbegeschenk;
		result.Motorweltverzicht = this.motorweltverzicht;
		result.IstSchwerbehindert = this.istSchwerbehindert;
		result.Werbetext = this.werbetext;
		if (this.behindertenausweis) {
			result.Behindertenausweis = this.behindertenausweis.toRequestObject();
		}
		result.HatPartner = this.hatPartner;
		if (this.partner) {
			result.Partner = this.partner.toRequestObject();
		}
		result.HatKinder = this.hatKinder;
		const kinderArrayReqObject = [] as Array<object>;
		if (this.kinder && this.kinder.length > 0) {
			for (const child of this.kinder) {
				kinderArrayReqObject.push(child.toRequestObject());
			}
		}
		result.Kinder = kinderArrayReqObject;
		result.WiederrufAkzeptiert = this.WiderrufAkzeptiert;
		result.Englisch = this.englisch;
		if (this.userMailText) {
			result.UserMailText = this.userMailText;
		}
		if (this.attachments) {
			result.Attachments = this.attachments;
		}
		return result;
	}

}